<template>
  <div>
    <CustomerReceivedInvoicesFilters
      sender="HAUSEFUL"
      class="filter-section"
      :isDownloading="isDownloading"
      :downloadError="downloadError"
      :invoicesLength="customerHausefulInvoices.length"
      @downloadInvoiceZip="downloadInvoiceZip"
    />
    <v-data-table
      :no-data-text="$t('table.noResults')"
      :headers="headers"
      :items="customerHausefulInvoices"
      class="clickable"
      hide-default-footer
      calculate-widths
    >
      <template v-slot:item.hauseful_value="{ item }">
        <span>
          {{ item.hauseful_value ? formatMoney(item.hauseful_value) : '---' }}
        </span>
      </template>
      <template v-slot:item.created_at="{ item }">
        <span>
          {{ item.created_at ? formatDate(item.created_at) : '---' }}
        </span>
      </template>
      <template v-slot:item.file_response="{ item }">
        <v-btn v-if="item.file_response" @click="downloadInvoice(item.file_response.url)" color="grey" elevation="0" icon>
          <IconTooltip
            icon="mdi-download"
            :description="item.file_response.name"
            color="grey"
          />
        </v-btn>
        <span v-else>
          ---
        </span>
      </template>
    </v-data-table>

    <h-pagination :fetch="fetchCustomerInvoices" :requireOrderByFilter="false" :noBorders="true" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { catalogDateWithoutTime, catalogMonetary } from '@/util/catalog';
import { hausefulInvoiceHeaders } from '../customerInvoiceHeaders';
import { generateInvoiceZip } from '../customerInvoiceService';
import CustomerReceivedInvoicesFilters from './filters/CustomerReceivedInvoicesFilters';
import IconTooltip from '../../../../components/IconTooltip.vue';

export default {
  name: 'CustomerHausefulReceivedInvoices',

  components: {
    CustomerReceivedInvoicesFilters,
    IconTooltip,
  },

  computed: {
    ...mapGetters(['customerHausefulInvoices', 'isLoading', 'filters']),
  },

  data() {
    return {
      formatDate: catalogDateWithoutTime,
      formatMoney: catalogMonetary,
      headers: hausefulInvoiceHeaders,
      isDownloading: false,
      downloadError: null,
    };
  },

  methods: {
    ...mapActions(['fetchCustomerInvoices', 'showErrorMessage']),

    downloadInvoice(fileUrl) {
      window.open(fileUrl, '_blank');
    },

    async downloadInvoiceZip() {
      this.isDownloading = true;
      this.downloadError = null;

      try {
        if (!this.filters.creationStartDate || !this.filters.creationEndDate) {
          throw new Error('Filtros de data não estão definidos.');
        }

        const filterParams = {
          sender: 'HAUSEFUL',
          size: this.filters?.size || 100,
          page: this.filters?.page || 0,
          ...this.filters,
        };

        const response = await generateInvoiceZip(filterParams);

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invoices_pending_export.zip');
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Erro na requisição (HAUSEFUL):', {
          status: error.response ? error.response.status : 'Sem resposta',
          message: error.message,
          responseData: error.response ? error.response.data : null,
        });
        this.downloadError = this.$t('invoice.downloadError');
        this.showErrorMessage(this.$t('auth.errors.errorGeneratingPdf'));
      } finally {
        this.isDownloading = false;
      }
    },
  },
  mounted() {
    this.fetchCustomerInvoices('HAUSEFUL');
  },
};
</script>
<style scoped>
.error-text {
  color: red;
}
</style>
